import React from "react";
import Brand from "../../components/Brand/Brand";
import { SALES_EMAIL, useContent } from "./content";
import { useHomeLang } from "./homeLang";
import "./faq.css";

const WORDS = {
  it: { heading: "Domande frequenti", ask: "Hai ancora domande?", write: "Scrivici" },
  en: { heading: "Frequently asked questions", ask: "Still have questions?", write: "Email us" },
};

// The questions an advisor asks before trying, one open at a time beside a
// way to ask another.
export default function FaqSection() {
  const { FAQ } = useContent();
  const words = WORDS[useHomeLang()];
  return (
    <section id="faq" aria-labelledby="hf-h-faq" className="hf-sec hf-wrap fq">
      <div className="fq-side">
        <h2 id="hf-h-faq" className="t-h2">{words.heading}</h2>
        <p className="t-body fq-ask">{words.ask}</p>
        <a className="btn btn-quiet" href={`mailto:${SALES_EMAIL}`}>{words.write}</a>
      </div>
      <div className="fq-list">
        {FAQ.map(([q, a]) => (
          <details key={q} name="faq" className="fq-item">
            <summary>
              <span>{q}</span>
              <span className="fq-icon" aria-hidden="true" />
            </summary>
            <p className="t-body"><Brand>{a}</Brand></p>
          </details>
        ))}
      </div>
    </section>
  );
}
